import { useEffect, useRef, useState } from "react";
import PageContainer from "@components/layout/PageContainer";
import ModelIndex, { ModelIndexHandle } from "@components/layout/ModelIndex";
import styles from "./style.module.scss";
import { RoleApi, RoleDataType } from "@/api/RoleApi";
import { stripHtmlTags } from "@utils/Utils";
import { useNavigate } from "react-router-dom";
import { seedAdminRole } from "@/security/seed";
import { showAlert } from "@utils/Alert";
import LoadingScreen from "@components/content/LoadingScreen";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { useAdminContext } from "@/hooks/useAdminContext";

const RoleIndex = () => {
  const navigate = useNavigate()
  const modelRef = useRef<ModelIndexHandle>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const { adminTenantId, isAdminMode, profileBackUrl, adminQuerySuffix } = useAdminContext();

  useEffect(() => {
  }, []);

  const deleteRecord = async (id: string) => {
    const { errors } = await RoleApi.delete(id);
    if (errors?.length) {
      showAlert('danger', 'El rol no puedo ser eliminado');
    } else {
      showAlert('success', 'El rol fue eliminado correctamente');
    }
    modelRef.current?.refetch();
  }

  const resetAdminRole = async () => {
    try {
      setIsLoading(true)
      await seedAdminRole()
      modelRef.current?.refetch()
      showAlert("success", "Rol Admin reiniciado exitosamente")
    } catch (err) {
      showAlert("danger", "No fue posible reiniciar el rol de admin")
    } finally {
      setIsLoading(false)
    }
  }

  const fetchData = (...args: any[]) =>
    isAdminMode ? RoleApi.fetchAllByOwnerId(adminTenantId!) : RoleApi.fetchAll(...args);

  return (
    <PageContainer
      title="Roles de Usuario"
      backUrl={profileBackUrl}
      primaryActions={[
        {
          onClick: () => {
            navigate(`/user/acl/role${adminQuerySuffix}`)
          },
          actionTitle: "Nuevo",
          color: "success"
        }
      ]}
      secondaryActions={[
        {
          onClick: () => {
            navigate(`/user/acl/users${adminQuerySuffix}`)
          },
          actionTitle: "Usuarios",
        },
        {
          isVisible: !isAdminMode,
          onClick: () => {
            resetAdminRole()
          },
          actionTitle: "Reiniciar Rol Admin",
        }
      ]}
    >
      <ModelIndex<RoleDataType>
        ref={modelRef}
        fetchData={fetchData}
        filterProps={[
          {
            key: "name",
            filterType: "contains"
          },
          {
            key: "description",
            filterType: "contains"
          }
        ]}
        primaryProperties={[
          {
            key: "name",
            highlighted: true,
            className: styles.sequence
          },
        ]}
        primaryPropertiesSizing={
          [
            { sm: "4", xs: "12" },
          ]
        }
        secondaryProperties={[
          {
            key: "version",
            highlighted: true,
            title: "Version"
          },
          {
            key: (data) => {
              return stripHtmlTags(`${data.description || ""}`)
            },
            title: "Descripcion",
          }
        ]}
        secondaryPropertiesSizing={
          [
            { sm: "2", md: "2" },
            { sm: "7", md: "7" },
          ]
        }
        listActions={[
          {
            href: `/user/acl/role/{:id}${adminQuerySuffix}`,
            actionTitle: "Editar Rol",
            iconProps: { icon: faEdit }
          },
          {
            actionTitle: "Eliminar Rol",
            iconProps: { icon: faTrash },
            needConfirm: true,
            confirmProps: {
              title: "Eliminar Rol",
              confirmMessage: "¿Seguro que desea eliminar este Rol?",
              confirmBtnText: "Eliminar"
            },
            onClick: (id: string) => { deleteRecord(id) }
          }
        ]}
      >
      </ModelIndex>
      <LoadingScreen isLoading={isLoading} />
    </PageContainer >
  );
}

export default RoleIndex;
